const t = {
  name: "Warning",
  dimensions: { width: 40, height: 40 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2067)">
    <path d="M2 37.0029V35.0029H5.61H34.38H37C37.55 35.0029 38 35.4529 38 36.0029V38.0029H3C2.45 38.0029 2 37.5529 2 37.0029ZM11.39 24.0029H27.89C28.32 24.0029 28.7 24.2829 28.84 24.6829L31.61 33.0029H9.08C8.74 33.0029 8.5 32.6729 8.61 32.3429L11.39 24.0029ZM18.72 2.00293H20.56C20.99 2.00293 21.37 2.28293 21.51 2.68293L24.28 11.0029H16.42C16.08 11.0029 15.84 10.6729 15.95 10.3429L18.72 2.00293ZM27.95 22.0029H12.75C12.41 22.0029 12.17 21.6729 12.28 21.3429L15.05 13.0029H24.22C24.65 13.0029 25.03 13.2829 25.17 13.6829L27.95 22.0029ZM38 33.0029H33.72L23.18 1.37293C22.9 0.55293 22.14 0.00292969 21.28 0.00292969H18.72C17.86 0.00292969 17.1 0.55293 16.82 1.37293L6.28 33.0029H2C0.9 33.0029 0 33.9029 0 35.0029V38.0029C0 39.1029 0.9 40.0029 2 40.0029H38C39.1 40.0029 40 39.1029 40 38.0029V35.0029C40 33.9029 39.1 33.0029 38 33.0029Z" 00112C"/>
    </g>
    <defs>
    <clipPath id="clip0_27_2067">
    <rect width="40" height="40" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  t as Warning
};
